import { fillMissingDatesForDateLookBack } from 'src/components/therapyPlanning_2.0/commonComponent/converttherapyPlaningResponse';
import { replaceDataByKey } from 'src/components/therapyPlanning_2.0/commonComponent/updateSingleCellData';
import { therapyPlanningAction } from 'src/redux/actions/constant';

const {
  GET_7DAY_LOOK_BACK_SUM_REQUEST,
  GET_7DAY_LOOK_BACK_SUM_SUCCESS,
  GET_7DAY_LOOK_BACK_SUM_FAILURE,
  GET_7DAY_LOOK_BACK_SUM_RESET,
  GET_7DAY_LOOK_BACK_SUM_LOADING,
} = therapyPlanningAction;

const intitialstate: any = {
  response: null,
  loading: false,
  get7DayLookBackSum: false,
  get7DayLookBackSumData: null,
  requestDiscipline: null,
};

export const getTherapyPlanning7dayLookBack = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_7DAY_LOOK_BACK_SUM_SUCCESS:
      return {
        ...state,
        response: action.payload,
        loading: false,
        get7DayLookBackSum: true,
        get7DayLookBackSumData: fillMissingDatesForDateLookBack(
          action?.payload?.response?.data?.length ? action?.payload?.response?.data : [],
          action?.payload?.requestPayload?.startDate,
          action?.payload?.requestPayload?.endDate
        ),
        requestDiscipline: null,
      };

    case GET_7DAY_LOOK_BACK_SUM_FAILURE:
      return {
        ...state,
        response: action.payload,
        loading: false,
        get7DayLookBackSum: false,
      };
    case GET_7DAY_LOOK_BACK_SUM_LOADING:
      return {
        ...state,
        loading: true,
        requestDiscipline: action?.requestDiscipline,
      };

    case GET_7DAY_LOOK_BACK_SUM_RESET:
      return intitialstate;

    default:
      return state;
  }
};
